import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import AdminLoginPage from './pages/AdminLoginPage';
import DashboardPage from './pages/DashboardPage';
import SearchPage from './pages/SearchPage';
import ClientsManagement from './pages/ClientsManagement';
import DevicesManagement from './pages/DevicesManagement';
import ClientDetailsPage from './pages/ClientDetailsPage';
import HubDetailsPage from './pages/HubDetailsPage';
import HubTelemetryPage from './pages/HubTelemetryPage';
import HubEventsPage from './pages/HubEventsPage';
import FirmwarePage from './pages/FirmwarePage';
import PermissionsPage from './pages/PermissionsPage';
import ToolsPage from './pages/ToolsPage';
import FootageSharesPage from './pages/FootageSharesPage';
import './App.css';

const AppRoutes = () => {
    const { isAuthenticated, login } = useAuth();

    if (isAuthenticated === null) {
        return <div>Loading session...</div>;
    }

    return (
        <Routes>
            {/* Login route - always accessible, but redirects to /admin if already authenticated */}
            <Route 
                path="/login" 
                element={isAuthenticated ? <Navigate to="/admin" /> : <AdminLoginPage onAdminLogin={login} />} 
            />
            
            {/* Protected admin routes - only accessible when authenticated */}
            <Route 
                path="/admin" 
                element={isAuthenticated ? (
                    <Layout>
                        <DashboardPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/admin/search" 
                element={isAuthenticated ? (
                    <Layout>
                        <SearchPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/admin/clients" 
                element={isAuthenticated ? (
                    <Layout>
                        <ClientsManagement />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/admin/devices" 
                element={isAuthenticated ? (
                    <Layout>
                        <DevicesManagement />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/client/:clientId" 
                element={isAuthenticated ? (
                    <Layout>
                        <ClientDetailsPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
                        <Route 
                path="/hub/:hubId" 
                element={isAuthenticated ? (
                    <Layout>
                        <HubDetailsPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/hub/:hubId/telemetry" 
                element={isAuthenticated ? (
                    <Layout>
                        <HubTelemetryPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/hub/:hubId/events" 
                element={isAuthenticated ? (
                    <Layout>
                        <HubEventsPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/firmware"
                element={isAuthenticated ? (
                    <Layout>
                        <FirmwarePage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route 
                path="/admin/permissions" 
                element={isAuthenticated ? (
                    <Layout>
                        <PermissionsPage />
                    </Layout>
                ) : <Navigate to="/login" />} 
            />
            <Route
                path="/admin/tools"
                element={isAuthenticated ? (
                    <Layout>
                        <ToolsPage />
                    </Layout>
                ) : <Navigate to="/login" />}
            />
            <Route
                path="/admin/footage-shares"
                element={isAuthenticated ? (
                    <Layout>
                        <FootageSharesPage />
                    </Layout>
                ) : <Navigate to="/login" />}
            />
            
            {/* Root route - redirect based on authentication */}
            <Route 
                path="/" 
                element={<Navigate to={isAuthenticated ? "/admin" : "/login"} />} 
            />
            
            {/* Catch-all route - redirect based on authentication */}
            <Route 
                path="*" 
                element={<Navigate to={isAuthenticated ? "/admin" : "/login"} />} 
            />
        </Routes>
    );
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <AppRoutes />
            </Router>
        </AuthProvider>
    );
}

export default App;
